import React, { Component } from 'react';
import AOS from 'aos';
import { Link } from 'react-router-dom';
// import axios from 'axios';
import './LandingPage.css';
import AppContext from '../app/AppContext';
import { ReactComponent as MenuIcon } from '../../images/icons/menu.svg';
import { ReactComponent as CloseIcon } from '../../images/icons/close.svg';

class LandingPage extends Component {
    static contextType = AppContext;

    constructor () {
        super();

        this.state = {
            mobileNavOpen: false,
        };
    }

    componentDidMount () {
        window.addEventListener('scroll', this.handleNavScroll);
        window.addEventListener('scroll', this.handleStickyBar);
    }

    componentWillUnmount () {
        window.removeEventListener('scroll', this.handleNavScroll);
        window.removeEventListener('scroll', this.handleStickyBar);
    }

    handleNavScroll () {
        try {
            const headerHeight = document.querySelector('header').offsetHeight;
            const scroll = this.scrollY;
            const header = document.querySelector('header');
            if (scroll > headerHeight - 30) {
                header.classList.add('scrolled');
            }
            else {
                header.classList.remove('scrolled');
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    handleStickyBar () {
        try {
            const bodyHeight = document.querySelector('main').offsetHeight;
            const headerHeight = document.querySelector('header').offsetHeight;
            const reportHeight = document.querySelector('.report-section').offsetHeight;
            const scroll = this.scrollY;
            const sticky = document.querySelector('.sticky-report-bar');

            if (scroll > headerHeight - 30 && scroll < bodyHeight - (reportHeight + 1000)) {
                sticky.classList.remove('hidden-sticky');
            }
            else {
                sticky.classList.add('hidden-sticky');
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    toggleMobileNav = () => {
        this.setState({
            mobileNavOpen: !this.state.mobileNavOpen,
        });
    };

    render () {
        const { mobileNavOpen } = this.state;
        AOS.init();

        return (
            <div className="landing-page-parent">
                {/*eslint-disable*/}
                <link
                    rel="stylesheet"
                    href="https://cdnjs.cloudflare.com/ajax/libs/material-design-iconic-font/2.2.0/css/material-design-iconic-font.min.css"
                />
                {/* eslint-enable*/}
                <link href="https://unpkg.com/aos@2.3.1/dist/aos.css" rel="stylesheet" />
                <header>
                    <nav className="lp-navbar">
                        <a className="navbar-brand" href="/">
                            <img
                                className="navbar-img"
                                alt="Racecheck logo"
                                src={require('./landing-page-images/logo.png')}
                            />
                        </a>
                        <button
                            className="navbar-toggle"
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                            onClick={this.toggleMobileNav}
                        >
                            {mobileNavOpen ? (
                                <CloseIcon className="navbar-close" />
                            ) : (
                                <MenuIcon className="navbar-menu" />
                            )}
                        </button>

                        <div
                            className={`collapse navbar-collapse ${
                                mobileNavOpen ? 'collapsed-nav' : ''
                            }`}
                            id="navbarSupportedContent"
                        >
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <a className="nav-link" href="#get-started-section">
                                        Get started
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="#dashboard-section">
                                        Features
                                    </a>
                                </li>
                                <li className="nav-item mobile-nav-item-border">
                                    <Link to="/login" className="nav-link mobile-log-in-btn">
                                        Log in
                                    </Link>
                                </li>
                                <li className="nav-item nav-item-btn">
                                    <Link
                                        to={{
                                            pathname: '/signup'
                                        }}
                                        className="nav-link"
                                    >
                                        Sign up for free
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </header>
                
                <div className="lp-container">
                    <main>
                        <section className="global-section hero-section">
                            <div className="hero-image">
                                <img
                                    src={require('./landing-page-images/lp-img-1.png')}
                                    alt="Athlete reviewing and organiser benefitting"
                                    className="hero-main-img"
                                />
                            </div>
                            <div className="hero-copy">
                                <h1>Convert race reviews <br />into traffic and sales.</h1>
                                <h2>
                                    Racecheck Premium drives traffic to your event website and organically boosts registrations.
                                </h2>
                                <div className="hero-btn-wrap">
                                    <Link
                                        to="/signup"
                                    >
                                        <button className="hero-primary-btn">
                                            Sign up for free
                                        </button>
                                    </Link>
                                    <Link
                                        to="/book-demo"
                                    >
                                        <button className="hero-secondary-btn">
                                            Book a demo
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </section>

                        <section className="global-section testimonial-section">
                            <div className="testimonial-copy">
                                <p>USED BY WORLD CLASS EVENT ORGANISERS</p>
                            </div>
                            <div className="testimonial-images">
                                <img
                                    src={require('./landing-page-images/logo8-grey.png')}
                                    alt="Logo"
                                    className="testimonial-img"
                                />
                                <img
                                    src={require('./landing-page-images/logo2-grey.png')}
                                    alt="Logo"
                                    className="testimonial-img"
                                />
                                {/* <img
                                    src={require('./landing-page-images/logo3-grey.png')}
                                    alt="Logo"
                                    className="testimonial-img"
                                /> */}
                                <img
                                    src={require('./landing-page-images/logo9-grey.png')}
                                    alt="Logo"
                                    className="testimonial-img"
                                />
                                <img
                                    src={require('./landing-page-images/logo12-grey.png')}
                                    alt="Logo"
                                    className="testimonial-img"
                                />
                                <img
                                    src={require('./landing-page-images/logo6-grey.png')}
                                    alt="Logo"
                                    className="testimonial-img"
                                />
                                <img
                                    src={require('./landing-page-images/logo10-grey.png')}
                                    alt="Logo"
                                    className="testimonial-img"
                                />
                            </div>
                        </section>

                        <hr className="lp-divider" />

                        <section className="global-section why-section">
                            <h3>Why use Racecheck?</h3>
                            <div className="why-containers">
                                <div className="why-container">
                                    <div className="why-top">
                                        <img
                                            src={require('./landing-page-images/lp-img-2.png')}
                                            alt="Reviews surrounding a megaphone"
                                            className="why-img"
                                        />
                                        <p className="why-header">Boost SEO and attract more traffic</p>
                                        <p className="why-copy">A Racecheck star rating can appear as rich snippets next 
                                        to your Google listing, boosting your website click-through-rate 
                                        by <span>10%</span>*
                                        </p>
                                    </div>
                                    <p className="why-extra-info">* Estimated according to Google for listing with 
                                    rich snippets
                                    </p>
                                </div>
                                <div className="why-container">
                                    <div className="why-top">
                                        <img
                                            src={require('./landing-page-images/lp-img-3.png')}
                                            alt="Organiser looking at charts moving upwards"
                                            className="why-img"
                                        />
                                        <p className="why-header">Drive more organic event entries</p>
                                        <p className="why-copy">A Premium Racecheck Review Box can boost your entries 
                                        by <span>20%</span> and get a <span>30x</span> return on your investment*
                                        </p>
                                    </div>
                                    <p className="why-extra-info">* Results are estimated from a case study with over 
                                    30 events using the Premium Racecheck Review Box between May and July of 2021
                                    </p>
                                </div>
                            </div>
                        </section>

                        <hr className="lp-divider" />

                        <section className="global-section get-started-section" id="get-started-section">
                            <h3>Get started in 3 easy steps...</h3>
                            <div className="step-containers">
                                <div className="step-container">
                                    <div className="step-content">
                                        <div className="step-copy">
                                            <p className="step-count">
                                                STEP <span>1</span>
                                            </p>
                                            <p className="step-header">Create a free organiser<br />account in seconds</p>
                                        </div>
                                        <div className="step-img">
                                            <img
                                                src={require('./landing-page-images/lp-img-4.png')}
                                                alt="Organiser on a laptop"
                                                className="steps-img"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="step-container">
                                    <div className="step-content">
                                        <div className="step-copy">
                                            <p className="step-count">
                                                STEP <span>2</span>
                                            </p>
                                            <p className="step-header">Add or claim your<br />events in your dashboard</p>
                                        </div>
                                        <div className="step-img">
                                            <img
                                                src={require('./landing-page-images/lp-img-5.png')}
                                                alt="List of events in organiser dashboard"
                                                className="steps-img"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="step-container">
                                    <div className="step-content">
                                        <div className="step-copy">
                                            <p className="step-count">
                                                STEP <span>3</span>
                                            </p>
                                            <p className="step-header">Instantly receive and install<br />your Racecheck 
                                            Review Box
                                            </p>
                                        </div>
                                        <div className="step-img">
                                            <img
                                                src={require('./landing-page-images/lp-img-6.png')}
                                                alt="Organiser setting up their Review Box"
                                                className="steps-img"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <hr className="lp-divider" />

                        <section className="global-section dashboard-section" id="dashboard-section">
                            <h3>Your Racecheck Organiser Dashboard</h3>
                            <div className="screen-containers">
                                <div className="screen-container">
                                    <div className="screen-copy">
                                        <p className="screen-title">Streamlined <br />review feed</p>
                                        <p className="screen-desc">Read, reply to, bookmarks and share your reviews in 
                                        an organised and customisable feed.
                                        </p>
                                    </div>
                                    <div className="screen-img">
                                        <img
                                            src={require('./landing-page-images/ORGDASH-ReviewFeed.png')}
                                            alt="Screenshot of dashboard review feed"
                                        />
                                    </div>
                                </div>
                                <div className="screen-container">
                                    <div className="screen-copy">
                                        <p className="screen-title">Insightful <br />event analytics</p>
                                        <p className="screen-desc">Easy to digest reports take away the guesswork from 
                                        creating actionable tasks to improve year-on-year.
                                        </p>
                                    </div>
                                    <div className="screen-img">
                                        <img
                                            src={require('./landing-page-images/ORGDASH-Analytics.png')}
                                            alt="Screenshot of dashboard analytics"
                                        />
                                    </div>
                                </div>
                                <div className="screen-container">
                                    <div className="screen-copy">
                                        <p className="screen-title">Review box <br />management</p>
                                        <p className="screen-desc">From quick and easy setup to detailed engagement 
                                        reports. Everything you need to maximise the use of your Racecheck Review Box.
                                        </p>
                                    </div>
                                    <div className="screen-img">
                                        <img
                                            src={require('./landing-page-images/ORGDASH-ManageWidget.png')}
                                            alt="Screenshot of dashboard Review Box management"
                                        />
                                    </div>
                                </div>
                            </div>
                        </section>

                        <hr className="lp-divider" />

                        <section className="global-section full-testimonial-section">
                            <h3>Trusted by local and global organisers</h3>
                            <div className="quote-containers">
                                <div className="quote-container">
                                    <div className="quote-img">
                                        <img
                                            src={require('./landing-page-images/logo2-grey.png')}
                                            alt="Logo"
                                            className="testimonial-img"
                                        />
                                    </div>
                                    <div className="quote-body">
                                        <p>“Racecheck reviews help us to showcase swimmers’ opinions to those that 
                                            have yet to experience a Henley Swim for themselves is an incredibly 
                                            useful tool.”
                                        </p>
                                    </div>
                                    <div className="quote-credit">
                                        <p className="quote-author">Juliet Hulme</p>
                                        <p className="quote-org">Henley Swim Race Director</p>
                                    </div>
                                </div>
                                <div className="quote-container">
                                    <div className="quote-img">
                                        <img
                                            src={require('./landing-page-images/logo3-grey.png')}
                                            alt="Logo"
                                            className="testimonial-img"
                                        />
                                    </div>
                                    <div className="quote-body">
                                        <p>“Racecheck helps us by facilitating entirely honest and independently 
                                            managed - warts and all - feedback about how good or how bad an 
                                            event actually is.”
                                        </p>
                                    </div>
                                    <div className="quote-credit">
                                        <p className="quote-author">David Kelly</p>
                                        <p className="quote-org">Run Series Founder & Race Director</p>
                                    </div>
                                </div>
                                <div className="quote-container">
                                    <div className="quote-img">
                                        <img
                                            src={require('./landing-page-images/logo11-grey.png')}
                                            alt="Logo"
                                            className="testimonial-img"
                                        />
                                    </div>
                                    <div className="quote-body">
                                        <p>“Racecheck reviews help us to understand if we need to make any changes 
                                            or improvements to our events. Every year we come up with a list 
                                            that we work from.”
                                        </p>
                                    </div>
                                    <div className="quote-credit">
                                        <p className="quote-author">Andy Hully</p>
                                        <p className="quote-org">MK Marathon Weekend Founder & Race Director</p>
                                    </div>
                                </div>
                                <div className="quote-container">
                                    <div className="quote-img">
                                        <img
                                            src={require('./landing-page-images/logo1-grey.png')}
                                            alt="Logo"
                                            className="testimonial-img"
                                        />
                                    </div>
                                    <div className="quote-body">
                                        <p>“We use Racecheck as a stamp of approval. In a really crowded environment 
                                            something this simple might make a competitor choose to enter my 
                                            event over another.”
                                        </p>
                                    </div>
                                    <div className="quote-credit">
                                        <p className="quote-author">Paul Albon</p>
                                        <p className="quote-org">Big Bear Events Race Director</p>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </div>

                <footer className="lp-footer">
                    <div className="lp-footer-container">
                        <div className="lp-footer-content">
                            <div className="lp-footer-brand">
                                <div className="lp-footer-logo">
                                    <img
                                        src={require('./landing-page-images/logo.png')}
                                        alt="Racecheck Logo"
                                    />
                                </div>
                                <div className="lp-footer-address">
                                    <p>
                                        Office 3. 09, Scott House Suite 1, The Concourse, Waterloo Station, London
                                        SE1 7LY, UK.
                                    </p>
                                </div>
                            </div>

                            <div className="lp-footer-pages">
                                <ul className="lp-footer-links">
                                    <li>
                                        <a href="https://racecheck.com/about/">ABOUT US</a>
                                    </li>
                                    <li>
                                        <a href="https://racecheck.com/contact/">CONTACT US</a>
                                    </li>
                                    <li>
                                        <a href="https://racecheck.com/terms_conditions/">T&Cs</a>
                                    </li>
                                    <li>
                                        <a href="https://racecheck.com/privacy_policy/">PRIVACY POLICY</a>
                                    </li>
                                    <li>
                                        <a href="https://racecheck.com/">RACECHECK FOR PARTICIPANTS</a>
                                    </li>
                                    <li>
                                        <a href="https://racecheck.com/racecheck-for-developers/">
                                            RACECHECK FOR DEVELOPERS
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className="lp-footer-socials">
                                <ul className="lp-footer-social-links">
                                    <li>
                                        <a href="https://twitter.com/racecheck">
                                            <i className="zmdi zmdi-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/racecheck/">
                                            <img
                                                src={require('./landing-page-images/icons/instagram.svg')}
                                                alt="Instagram logo"
                                            />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.facebook.com/racecheck">
                                            <i className="zmdi zmdi-facebook" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="lp-footer-copyright">
                            <p>Copyright &copy; 2022 Racecheck</p>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

export default LandingPage;
